import React from 'react';

const Label = ({required, htmlFor, children, className}) => !children ? null :
	<label htmlFor={htmlFor} className={className}>
		{children} {required ? <span className='text-danger'>*</span> : null}
	</label>
;

export default Label;
